module.exports = __webpack_public_path__ + "img/upi.0f35236b.png";